import { styled } from 'goober';

const Item = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
  padding: 6px 8px;
  border-radius: 6px;
  font-size: 12px;
  transition: all 0.2s ease;
  &:hover {
    background: var(--hover-bg);
  }
  &:last-child {
    margin-bottom: 0;
  }
`;

const ColorPicker = styled('input')`
  width: 20px;
  height: 20px;
  border: 2px solid var(--input-border);
  border-radius: 4px;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  transition: all 0.2s ease;
  &:hover {
    transform: scale(1.1);
    border-color: var(--accent);
  }
`;

const Label = styled('span')`
  color: var(--text);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
`;

interface LegendItemProps {
  type: string;
  color: string;
  onColorChange: (newColor: string) => void;
}

export function LegendItem({ type, color, onColorChange }: LegendItemProps) {
  const handleChange = (event: Event) => {
    const input = event.target as HTMLInputElement;
    onColorChange(input.value);
  };

  return (
    <Item data-testid="legend-item">
      <ColorPicker
        type="color"
        data-testid="legend-color-picker"
        value={color}
        title="Changer la couleur"
        onChange={handleChange}
      />
      <Label data-testid="legend-label">{type}</Label>
    </Item>
  );
}
